const StripeSessionMode = {
  PAYMENT: 'payment',
  SUBSCRIPTION: 'subscription',
};

export default StripeSessionMode;
